import { useState } from "react";

const statItems = [
  { value: "1200+", label: "连载漫画" },
  { value: "800万+", label: "累计阅读" },
  { value: "68万", label: "追更读者" },
  { value: "24h", label: "每日更新" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (keyword.trim()) {
      document.getElementById("category")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="home" className="relative w-full overflow-hidden bg-foreground-950">
      {/* Background */}
      <img
        src="https://readdy.ai/api/search-image?query=Vibrant%20stylized%20comic%20artwork%20with%20laughing%20cartoon%20characters%2C%20speech%20bubbles%2C%20stars%20and%20confetti%20on%20warm%20orange%20to%20yellow%20background%2C%20playful%20silly%20meme%20manga%20style%2C%20high%20energy%2C%20abstract%20and%20artistic%2C%20not%20photorealistic&width=1800&height=1100&seq=hero-bg&orientation=landscape"
        alt="开心漫画网沙雕漫画专场插画背景"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
      <div className="absolute inset-0 halftone-light opacity-60"></div>

      <div className="relative w-full px-4 md:px-6 flex flex-col items-center justify-center text-center min-h-[560px] md:min-h-[720px] pt-24 pb-16">
        <div className="w-full max-w-4xl mx-auto flex flex-col items-center">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-400 text-foreground-950 text-xs md:text-sm font-bold mb-5 shadow-comic-sm">
            <i className="ri-fire-fill" aria-hidden="true"></i>
            沙雕漫画 · 无厘头 · 神转折 · 魔性追更
          </span>

          <h1 className="font-heading text-background-50 text-3xl md:text-6xl leading-tight tracking-wide drop-shadow">
            开心漫画网
          </h1>
          <p className="font-heading text-secondary-300 text-xl md:text-4xl mt-2 md:mt-4">
            专供无厘头脑洞与奇葩剧情
          </p>

          <p className="text-background-100/90 text-sm md:text-lg mt-5 max-w-2xl">
            神转折一话接一话，魔性画风搭配爆笑展开。适合喜欢出其不意的你——每日精选更新，
            点开就能收获快乐，越看越上头。
          </p>

          <div className="w-full max-w-xl mt-7">
            <form
              onSubmit={onSearch}
              className="flex flex-col sm:flex-row gap-2 sm:gap-0 sm:rounded-full sm:overflow-hidden bg-background-50 p-1.5 shadow-comic"
              role="search"
            >
              <div className="flex-1 flex items-center px-3 gap-2">
                <i className="ri-search-line text-foreground-500 text-lg" aria-hidden="true"></i>
                <input
                  type="search"
                  value={keyword}
                  onChange={(e) => setKeyword(e.target.value)}
                  placeholder="搜索沙雕漫画、神转折、脑洞作品…"
                  className="w-full py-2.5 text-sm text-foreground-900 bg-transparent outline-none placeholder:text-foreground-400"
                  aria-label="搜索漫画"
                />
              </div>
              <button
                type="submit"
                className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition whitespace-nowrap"
              >
                搜索快乐
              </button>
            </form>
          </div>

          <div className="flex flex-wrap justify-center gap-3 mt-6">
            <a
              href="#hot"
              className="px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-bold hover:bg-primary-600 transition whitespace-nowrap shadow-comic"
            >
              立即开看
            </a>
            <a
              href="#category"
              className="px-6 py-3 rounded-full bg-background-50/90 text-foreground-900 text-sm font-bold hover:bg-background-50 transition whitespace-nowrap"
            >
              浏览分类
            </a>
          </div>

          <dl className="w-full grid grid-cols-2 sm:grid-cols-4 gap-3 md:gap-6 mt-10 max-w-2xl">
            {statItems.map((s) => (
              <div
                key={s.label}
                className="rounded-xl bg-foreground-950/40 backdrop-blur border border-background-50/20 px-3 py-3 md:py-4"
              >
                <dt className="font-heading text-secondary-300 text-xl md:text-2xl">{s.value}</dt>
                <dd className="text-background-100/85 text-xs mt-1">{s.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}